module.exports = __webpack_public_path__ + "static/media/thankview.4b80e7b7.svg";